exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".block{background-color:#f3f2ed;margin-top:3em;margin-bottom:3em;padding:2em}.block p{margin-bottom:2em}.block p:first-child{font-weight:700;font-size:20px;line-height:27px;color:#315870}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/user-club/user-club-unsubscribe/user-club-unsubscribe.component.scss
// module id = 752
// module chunks = 0